<template>
  <div class="workbench-approval">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="approval-main">
      <!-- <el-collapse v-model="collapseActiveName" accordion>
        <el-collapse-item name="1"> -->
          <!-- <template slot="title">
            <el-badge :value="pendingApprovalTotal" class="item"><i class="el-icon-damai-hetong"></i>合同审批123</el-badge>
          </template> -->
          <div>
            <el-tabs v-model="gasActiveName" type="card">
              <el-tab-pane label="待我审批" name="gasPendingApproval">
                <table-main :tableHeight="520" :selection="false" :tableHead="gasPendingApprovalTableHead" @seeExample="seeExample" :tableData="gasPendingApprovalTableData" :operationArr="gasPendingApprovalOperationArr" @electricApproveRow="gasApproveRow" @electricUnApproveRow="gasUnApproveRow" :total="gasPendingApprovalTotal" :pageNum="gasPendingApprovalPageNum" :pageSize="gasPendingApprovalPageSize" @changePagination="changeGasPendingApprovalPagination"  />
              </el-tab-pane>
              <el-tab-pane label="我已审批" name="gasApproved">
                <table-main :tableHeight="520" :selection="false" :tableHead="gasApprovedTableHead" @seeExample="seeExample" :tableData="gasApprovedTableData" :operationArr="gasApprovedOperationArr" @toDetailsPage="toDetailsPage" :total="gasApprovedTotal" :pageNum="gasApprovedPageNum" :pageSize="gasApprovedPageSize" :hasOperation="false" @changePagination="changeGasApprovedPagination" />
              </el-tab-pane>
              <el-tab-pane label="我发起的" name="gasSponsored">
                <table-main :tableHeight="520" :selection="false" :tableHead="gasSponsoredTableHead" @seeExample="seeExample" :tableData="gasSponsoredTableData" :operationArr="gasSponsoredOperationArr" @toDetailsPage="toDetailsPage" :total="gasSponsoredTotal" :pageNum="gasSponsoredPageNum" :pageSize="gasSponsoredPageSize" :hasOperation="false" @changePagination="changeGasSponsoredPagination" />
              </el-tab-pane>
            </el-tabs>
          </div>
        <!-- </el-collapse-item>
      </el-collapse> -->

    </div>
       <!--燃气-->
    <div class="approveDialogBox">
      <el-dialog title="同意意见" :visible.sync="gasApproveDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">同意意见</div>
            <el-input type="textarea" :rows="4" placeholder="同意意见" v-model="gasApproveMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="gasCancelApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="gasPassSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="驳回意见" :visible.sync="gasApproveRejectDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">驳回意见</div>
            <el-input type="textarea" :rows="4" placeholder="驳回意见" v-model="gasRejectMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="gasCancelReject">取 消</el-button>
          <el-button size="small" type="primary" @click="gasUnpassSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <el-dialog title="审批进度" :visible.sync="flowDialog" style="margin-top:200px">
      <el-steps :active="currentRate" align-center finish-status="success">
        <el-step :title="applyData.status=='4'?applyData.sponsorAccountName+'已撤回':applyData.sponsorAccountName+'发起审批'" :description="applyData.sponsorDate"></el-step>
        <el-step v-if="applyData.status!='4'" v-for="(item, index) in flowData" :key="item.code" :title="item.statusText" :description="item.approveDate" :status="item.status&&item.status!='1'?item.status=='3' ? 'error' : 'success':''"></el-step>
      </el-steps>
    </el-dialog>


  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TableMain from "../../../components/Table/TableMain";
import { errorHandler } from "../../../utils/errorHandler";
import { nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import { api } from "../../api/WorkbenchApproval";

export default {
  components: {
    TableMain,
    Breadcrumb,
  },
  name: "workbench-approval",
  data() {
    return {
      yqCode: "",
      breadcrumb: [
        {
          value: "待办事项",
          name: "contract-approval",
        },
        {
          value: "燃气充值审批",
        },
      ],
      collapseActiveName: "",
      gasCollapseItemTitle: "燃气充值审批",
      accountCode: "",
      gasActiveName: "gasPendingApproval",

      // 我发起的(燃气)
      gasSponsoredTableHead: [
        // {
        //   prop: "indexProgress",
        //   label: "审批进度",
        // },
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "memo",
          label: "审批意见",
        },
        {
          prop: "approveAccountName",
          label: "处理人",
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      gasSponsoredTableData: [],
      gasSponsoredOperationArr: ["details"],
      gasSponsoredTotal: 0,
      gasSponsoredPageNum: 1,
      gasSponsoredPageSize: 10,

      // 待我审批(燃气)
      gasPendingApprovalTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      gasPendingApprovalTableData: [],
      gasPendingApprovalOperationArr: [
        "electricApproveRow",
        "electricUnApproveRow",
      ],
      gasPendingApprovalTotal: 0,
      gasPendingApprovalPageNum: 1,
      gasPendingApprovalPageSize: 10,

      // 我已审批(燃气)
      gasApprovedTableHead: [
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "approveDate",
          label: "审批时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "memo",
          label: "审批意见",
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      gasApprovedTableData: [],
      gasApprovedOperationArr: ["details"],
      gasApprovedTotal: 0,
      gasApprovedPageNum: 1,
      gasApprovedPageSize: 10,

      gasApproveData: {},
      gasUnApproveData: {},
      gasApproveDialog: false,
      gasApproveMemo: "",
      gasApproveRejectDialog: false,
      gasRejectMemo: "",

      operationArr: ["modifySuggestions"],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      requestData: {
        responsiblePersonCode: "",
        searchKey: "",
        result: "",
        status: "0",
      },

      flowDialog:false,
      applyData:{},
      chainList:[],
      flowData:{},
      currentRate:0
    };
  },
  created() {
    this.yqCode = bus.global.yqCode;
    this.requestData.responsiblePersonCode = bus.global.accountCode;
    this.accountCode = bus.global.accountCode;
    this.getPageByGasPendingApprovalPage();
  },
  mounted() {
    if (this.$route.params.workType) {
      this.activeName = this.$route.params.workType;
    }
  },
  methods: {
    // 跳转审批详情页面
    toDetailsPage(data) {
      sessionStorage.setItem("workDetailData", JSON.stringify(data));
      sessionStorage.setItem("workDetailActiveName", this.activeName);
      if (data.type === "其他合同") {
        this.$router.push({
          name: "other-approval-detail",
        });
      } else {
        this.$router.push({
          name: "approval-detail",
        });
      }
    },

    // 我发起的页码跳转(燃气)
    changeGasSponsoredPagination(data) {
      this.gasSponsoredPageNum = data[0];
      this.gasSponsoredPageSize = data[1];
      this.getPageByGasSponsorAccountCode();
    },

    // 待我审批页码跳转(燃气)
    changeGasPendingApprovalPagination(data) {
      this.gasPendingApprovalPageNum = data[0];
      this.gasPendingApprovalPageSize = data[1];
      this.getPageByGasPendingApprovalPage();
    },

    // 我已审批页码跳转(燃气)
    changeGasApprovedPagination(data) {
      this.gasApprovedPageNum = data[0];
      this.gasApprovedPageSize = data[1];
      this.getPageByGasApprovedPage();
    },

    // 我发起的(燃气)
    getPageByGasSponsorAccountCode() {
      let reqData = {};
      reqData.pageNum = this.gasSponsoredPageNum;
      reqData.pageSize = this.gasSponsoredPageSize;
      reqData.sponsorAccountCode = this.accountCode;
      this.$axios
        .post(api.getGasApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.index === 1) {
                v.indexProgress = "1级审批";
              } else if (v.index === 2) {
                v.indexProgress = "2级审批";
              } else if (v.index === 3) {
                v.indexProgress = "3级审批";
              }
              if (v.status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.gasSponsoredTotal = res.data.data.total;
            this.gasSponsoredTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 待我审批(燃气)
    getPageByGasPendingApprovalPage() {
      let reqData = {};
      reqData.pageNum = this.gasPendingApprovalPageNum;
      reqData.pageSize = this.gasPendingApprovalPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.status = "1";
      this.$axios
        .post(api.getGasApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.index === 1) {
                v.indexProgress = "1级审批";
              } else if (v.index === 2) {
                v.indexProgress = "2级审批";
              } else if (v.index === 3) {
                v.indexProgress = "3级审批";
              }
              if (v.status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.gasPendingApprovalTotal = res.data.data.total;
            this.gasPendingApprovalTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 我已审批(燃气)
    getPageByGasApprovedPage() {
      let reqData = {};
      reqData.pageNum = this.gasApprovedPageNum;
      reqData.pageSize = this.gasApprovedPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.status = "2,3";
      this.$axios
        .post(api.getGasApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.status === "1") {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else if (v.status === "2") {
                v.workState = "审批通过";
                v.fontColorToPeople = "#00A0E6";
              } else if (v.status === "3") {
                v.workState = "审批驳回";
                v.fontColorToPeople = "#B22222";
              }
            });
            this.gasApprovedTotal = res.data.data.total;
            this.gasApprovedTableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 燃气审批通过
    gasApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.gasApproveData = data;
      this.gasApproveDialog = true;
    },
    // 燃气审批驳回
    gasUnApproveRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.gasUnApproveData = data;
      this.gasApproveRejectDialog = true;
    },

    // 取消通过
    cancelApprove() {
      this.approveMemo = "";
      this.approveDialog = false;
    },

    // 确认通过
    passSubmit() {
      this.electricApproveData.memo = this.approveMemo;
      this.$axios
        .post(api.passElectricApprove, this.electricApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.approveMemo = "";
            this.approveDialog = false;
            nSuccess("审批已通过");
            this.getPageByElectricPendingApprovalPage();
          }
        })
        .catch(errorHandler("通过失败"));
    },

    // 取消驳回
    cancelReject() {
      this.rejectMemo = "";
      this.approveRejectDialog = false;
    },

    // 确认驳回
    unpassSubmit() {
      this.electricUnApproveData.memo = this.rejectMemo;
      this.$axios
        .post(api.unPassElectricApprove, this.electricUnApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.rejectMemo = "";
            this.approveRejectDialog = false;
            nSuccess("审批已驳回");
            this.getPageByElectricPendingApprovalPage();
          }
        })
        .catch(errorHandler("驳回失败"));
    },

    // 取消通过(燃气)
    gasCancelApprove() {
      this.gasApproveMemo = "";
      this.gasApproveDialog = false;
    },

    // 确认通过(燃气)
    gasPassSubmit() {
      this.gasApproveData.memo = this.gasApproveMemo;
      this.$axios
        .post(api.passGasApprove, this.gasApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.gasApproveMemo = "";
            this.gasApproveDialog = false;
            nSuccess("审批已通过");
            this.getPageByGasPendingApprovalPage();
          }
        })
        .catch(errorHandler("通过失败"));
    },

    // 取消驳回(燃气)
    gasCancelReject() {
      this.gasRejectMemo = "";
      this.gasApproveRejectDialog = false;
    },

    // 确认驳回(燃气)
    gasUnpassSubmit() {
      this.gasUnApproveData.memo = this.gasRejectMemo;
      this.$axios
        .post(api.unPassGasApprove, this.gasUnApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.gasRejectMemo = "";
            this.gasApproveRejectDialog = false;
            nSuccess("审批已驳回");
            this.getPageByGasPendingApprovalPage();
          }
        })
        .catch(errorHandler("驳回失败"));
    },
    seeExample(data){
      this.$axios.post(api.getGasApproveFlow, {outTradeNo: data.outTradeNo}).then(res=>{
        this.applyData=res.data.data.apply
        this.chainList=res.data.data.chainList
        this.flowData=res.data.data.flow.flowDetails
        if(this.applyData.status && this.applyData.status=='4'){
          this.flowDialog=true;
          this.currentRate=0
          return;
        }
        this.flowData.map(u=>{
          u.statusText=u.accountName
          this.chainList.map(v=>{
            if(v.approveAccountCode==u.accountCode){
              u.approveDate=v.approveDate
              u.status=v.status
              if(v.status=='2'){
                u.statusText=u.accountName+'已通过'
              } else if(v.status=='3'){
                u.statusText=u.accountName+'已驳回'
              }
            }
          })
        })
        this.flowData.map(v=>{
          let accountCode = v.accountCode;
          this.chainList.map(u=>{
            if(accountCode == u.approveAccountCode){
              if(u.status=='1'){
                this.currentRate =+ u.index;
              }else{
                this.currentRate =+ u.index+1;
              }
            }
          })
        })
        // this.flowData.map(v=>{
        //   if(v.accountCode==this.chainList[0].sponsorAccountCode){
        //     if(this.chainList[0].status=='1'){
        //       this.currentRate=+this.chainList[0].index
        //     }else{
        //       this.currentRate=+this.chainList[0].index+1
        //     }
        //   }
        // })
        this.flowDialog=true
      }).catch(errorHandler("获取审批进度失败"))
    }
  },
  watch: {
    gasActiveName(val) {
      if (val === "gasSponsored") {
        this.gasSponsoredPageNum = 1;
        this.gasSponsoredPageSize = 10;
        this.getPageByGasSponsorAccountCode();
      } else if (val === "gasPendingApproval") {
        this.gasPendingApprovalPageNum = 1;
        this.gasPendingApprovalPageSize = 10;
        this.getPageByGasPendingApprovalPage();
      } else if (val === "gasApproved") {
        this.gasApprovedPageNum = 1;
        this.gasApprovedPageSize = 10;
        this.getPageByGasApprovedPage();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.workbench-approval {
  /deep/ .el-collapse-item__header {
    height: 60px;
    line-height: 60px;
  }
  .item {
    font-size: 16px;
    line-height: 28px;
    margin-right: 29px;
    .el-badge__content.is-fixed {
      top: 2px;
      right: 5px;
    }
    i {
      width: 40px;
      font-size: 18px;
      color: #00a0e6;
      margin-right: 5px;
    }
  }
  .breadcrumb-box {
    border-bottom: 0 !important;
  }
  .el-tabs__active-bar {
    width: 96px !important;
  }
  .el-tabs--top {
    height: 100%;
    .is-top:nth-child(2) {
      /*padding-left: 20px!important;*/
      padding: 0 20px 0 0;
    }
    #tab-pendingApproval {
      /*margin: 0 20px 0 0;*/
    }
    .is-top:last-child {
      /*padding-left: 0;*/
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }

  .approval-main {
    height: 96%;
    /*padding: 10px 10px 0 10px;*/
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    h4 {
      border-left: 3px solid #00a0e6;
      padding-left: 5px;
      font-size: 16px;
      line-height: 16px;
      font-weight: 400;
      text-align: left;
    }
    .approval-main-top {
      height: 45%;
      .all-table-class .el-table td {
        padding: 3px 0;
      }
    }
    .approval-main-bottom {
      height: 45%;
      .all-table-class .el-table td {
        padding: 8px 0;
      }
    }
    .el-tabs__content {
      padding-bottom: 20px;
      height: 100%;
    }
  }

  .approveDialogBox {
    text-align: left;
    .el-dialog {
      width: 800px;
    }
    .approveMainBox {
      text-align: center;
    }
    .approve_title {
      width: 120px;
    }
    .approveFlexBox {
      width: 500px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: flex-start;
    }
    .red {
      color: red;
    }
  }
  /deep/ .el-tabs__item.is-active {
    background-color: #1362ff;
    color: #fff;
    border-radius: 3px;
  }
  /deep/ .breadcrumb-box {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
    border-bottom: 1px solid #e4e7ed !important;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #1362ff;
  }
}
/deep/ .el-step__description {
  margin-top: -8em ;
}
/deep/ .el-dialog__body{
  padding:50px 0 ;
  color: #1362FF ;
}
/deep/.el-step__head.is-success{
  color: #1362FF ;
  border-color: #1362FF ;
}
/deep/.el-step__title.is-success{
  color: #1362FF ;
}
/deep/.el-step__description.is-success{
  color:#1362FF ;
}
</style>



// WEBPACK FOOTER //
// src/view/PendingItems/GasApproval/GasApproval.vue